(()=>{
const limits = Object.freeze({ travel:[0,180], waiting:[0,120], setup:[0,120], sessions:[0,14], workout:[5,180], weeks:[0,52] });
function estimateTime(values) {
  const invalid = Object.entries(limits).filter(([key,[min,max]]) => values[key] === '' || values[key] === null || !Number.isInteger(Number(values[key])) || Number(values[key]) < min || Number(values[key]) > max).map(([key]) => key);
  if (invalid.length) return { valid:false, invalid };
  const v=Object.fromEntries(Object.keys(limits).map(key=>[key,Number(values[key])]));
  const difference=v.travel+v.waiting-v.setup;
  return {valid:true,...v,gym:v.workout+v.travel+v.waiting,home:v.workout+v.setup,difference,weekly:difference*v.sessions,annual:difference*v.sessions*v.weeks};
}
function durationParts(minutes) { const n=Math.abs(minutes);return {hours:Math.floor(n/60),minutes:n%60}; }

const root=document.querySelector('.bp[data-audience="busy-parents"]');
if (root) {
  const $=selector=>root.querySelector(selector);
  const form=$('#bp-time-form');
  const fields=Array.from(form.querySelectorAll('input[name]'));
  const result=$('.bp-time-result');
  const integer=new Intl.NumberFormat(document.documentElement.lang||'en-AU');
  const decimal=new Intl.NumberFormat(document.documentElement.lang||'en-AU',{maximumFractionDigits:1});
  function renderEstimate() {
    const values=Object.fromEntries(fields.map(field=>[field.name,field.value]));
    const time=estimateTime(values);
    root.querySelectorAll('[data-trip]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.trip)===Number(values.travel)&&values.travel!=='')));
    root.querySelectorAll('[data-frequency]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.frequency)===Number(values.sessions)&&values.sessions!=='')));
    fields.forEach(field=>field.setAttribute('aria-invalid',String(!time.valid&&time.invalid.includes(field.name))));
    result.dataset.invalid=String(!time.valid);
    $('#bp-calc-error').hidden=time.valid;
    if (!time.valid) {$('#bp-result-label').textContent='Check your routine';return;}
    $('#bp-result-label').textContent=time.weekly>0?'Time back each week':time.weekly<0?'Extra time at home each week':'No time difference each week';
    const d=durationParts(time.weekly);
    $('#bp-weekly').innerHTML=(d.hours?`${integer.format(d.hours)}<span>h</span> `:'')+`${integer.format(d.minutes)}<span>min</span>`;
    if(time.weekly===0){
      $('#bp-annual').textContent='Your current inputs give equal weekly totals.';
    } else if (time.annual>0) {
      const daysFmt=decimal.format(time.annual/60/24);
      $('#bp-annual').innerHTML=`That’s <strong>${decimal.format(time.annual/60)} hours a year</strong>. About ${daysFmt} ${daysFmt==='1'?'day':'days'} with your family, not on the road.`;
    } else {
      $('#bp-annual').innerHTML=`That’s <strong>${decimal.format(Math.abs(time.annual)/60)} extra hours a year</strong> at home with these inputs.`;
    }
    $('#bp-preset-hint').textContent=time.valid?`Based on a ${integer.format(time.travel)}-minute round trip and ${integer.format(time.sessions)} session${time.sessions===1?'':'s'} a week. Tap any option to make it yours.`:'Adjust the details above to see your own routine.';
    $('#bp-gym-minutes').textContent=`${time.gym} min`;
    $('#bp-home-minutes').textContent=`${time.home} min`;
    $('.bp-journey').setAttribute('aria-label',`${time.workout}-minute workout: ${time.gym} minutes for a gym trip, ${time.home} minutes at home.`);
    const largest=Math.max(time.gym,time.home);
    $('.bp-timeline').style.width=`${time.gym/largest*100}%`;
    $('#bp-home-bar').style.width=`${time.home/largest*100}%`;
    for(const [id,val] of [['bp-gym-extra',time.travel+time.waiting],['bp-gym-training',time.workout],['bp-home-extra',time.setup],['bp-home-training',time.workout]]){
      const segment=$('#'+id);segment.style.flex=String(val);segment.hidden=val===0;
      segment.textContent=val/largest>=.075?`${val} min`:'';
      if(segment.textContent&&segment.offsetWidth<48)segment.textContent='';
    }
    $('#bp-result-note').textContent=time.sessions===0?'Choose a weekly routine to compare your time.':time.weekly>0?'The workout stays. The round trip goes.':time.weekly<0?'With these inputs, home setup takes longer than the gym journey.':'Either way, your workout happens at home instead of the gym.';
  }
  function paintSlider(slider){slider.style.setProperty('--fill',`${(Number(slider.value)-Number(slider.min))/(Number(slider.max)-Number(slider.min))*100}%`);}
  root.querySelectorAll('[data-sync]').forEach(slider=>{
    paintSlider(slider);
    slider.addEventListener('input',()=>{form.elements[slider.dataset.sync].value=slider.value;paintSlider(slider);renderEstimate();});
  });
  fields.forEach(field=>field.addEventListener('input',()=>{
    const slider=root.querySelector(`[data-sync="${field.name}"]`);
    if(slider&&field.value!==''&&field.validity.valid){slider.value=field.value;paintSlider(slider);}
    renderEstimate();
  }));
  form.addEventListener('submit',event=>event.preventDefault());
  root.querySelectorAll('[data-trip]').forEach(button=>button.addEventListener('click',()=>{form.elements.travel.value=button.dataset.trip;const slider=$('[data-sync="travel"]');slider.value=button.dataset.trip;paintSlider(slider);renderEstimate();}));
  root.querySelectorAll('[data-frequency]').forEach(button=>button.addEventListener('click',()=>{form.elements.sessions.value=button.dataset.frequency;const slider=$('[data-sync="sessions"]');slider.value=button.dataset.frequency;paintSlider(slider);renderEstimate();}));
  renderEstimate();
  let resizeTimer;
  window.addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(renderEstimate,150);});

  const film=$('#bp-family-film');const filmToggle=$('#bp-family-toggle');
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  let filmPausedByUser=false;
  function filmButton(){filmToggle.innerHTML=film.paused?'Play family film <span aria-hidden="true">▷</span>':'Pause film <span aria-hidden="true">Ⅱ</span>';filmToggle.setAttribute('aria-label',film.paused?'Play family film':'Pause family film');}
  film.addEventListener('playing',()=>{film.classList.add('is-playing');filmButton();});film.addEventListener('pause',filmButton);
  film.addEventListener('error',()=>{film.classList.remove('is-playing');filmToggle.hidden=true;});
  filmToggle.addEventListener('click',()=>{if(film.paused){filmPausedByUser=false;film.play().catch(()=>filmButton());}else{filmPausedByUser=true;film.pause();}});
  reducedMotion.addEventListener('change',event=>{if(event.matches){film.pause();filmPausedByUser=true;}});
  if(reducedMotion.matches){film.pause();filmPausedByUser=true;}
  filmButton();
  if('IntersectionObserver' in window){new IntersectionObserver(entries=>{for(const entry of entries){if(!entry.isIntersecting)film.pause();else if(!filmPausedByUser&&!reducedMotion.matches&&!navigator.connection?.saveData)film.play().catch(()=>{});}},{threshold:.35}).observe(film);}

  const features={
    guided:{image:'guided-workout',title:'Know what comes next.',description:'Follow an on-screen workout or build your own. Exercise demonstrations help you spend your time training, not planning every move.',detail:'A 23.8-inch screen that plans every set for you.',alt:'A woman choosing a workout on the actual Gym Monster 3 touchscreen'},
    weights:{image:'digital-weights',title:'A touch. A different weight.',description:'Adjust digital resistance on the screen between sets. Move through your workout without loading and unloading weight plates.',detail:'Gym Monster 3 offers up to 100 kg total digital resistance in 1 kg steps. Gym Monster 3S offers up to 120 kg.',alt:'A woman adjusting resistance on the Gym Monster 3 touchscreen'},
    fold:{image:'fold-away',title:'Your room, back again.',description:'Finish your session and fold the platform away. A home gym that makes room for the rest of your day.',detail:'0.26 m² is the folded storage footprint, about the size of a dining chair.',alt:'Gym Monster 3 folded upright next to an adult, with the entire machine visible'}
  };
  const tabs=Array.from(root.querySelectorAll('[data-feature]'));
  const initial=$('#bp-feature-image').src;
  // The production build supplies real Shopify asset URLs for each image.
  const manifestNode=$('#bp-feature-assets');
  const assetManifest=manifestNode?JSON.parse(manifestNode.textContent):null;
  const mediaUrl=(name,size)=>assetManifest?assetManifest[name][size]:new URL(`${name}-${size}.webp`,initial).href;
  function chooseFeature(tab,focus=false){
    const f=features[tab.dataset.feature];
    tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
    $('#bp-feature-panel').setAttribute('aria-labelledby',tab.id);
    const img=$('#bp-feature-image');img.src=mediaUrl(f.image,1680);img.srcset=`${mediaUrl(f.image,840)} 840w, ${mediaUrl(f.image,1680)} 1680w`;img.alt=f.alt;img.hidden=false;
    const video=$('#bp-feature-video');video.pause();video.hidden=true;
    $('#bp-feature-title').textContent=f.title;$('#bp-feature-description').textContent=f.description;$('#bp-feature-detail').textContent=f.detail;$('#bp-fold-film').hidden=tab.dataset.feature!=='fold';
    if(focus)tab.focus();
  }
  tabs.forEach((tab,index)=>{
    tab.addEventListener('click',()=>chooseFeature(tab));
    tab.addEventListener('keydown',event=>{
      let i;
      if(event.key==='ArrowRight')i=(index+1)%tabs.length;
      if(event.key==='ArrowLeft')i=(index-1+tabs.length)%tabs.length;
      if(event.key==='Home')i=0;
      if(event.key==='End')i=tabs.length-1;
      if(i!==undefined){event.preventDefault();chooseFeature(tabs[i],true);}
    });
  });
  $('#bp-fold-film').addEventListener('click',()=>{const video=$('#bp-feature-video');$('#bp-feature-image').hidden=true;video.hidden=false;$('#bp-fold-film').hidden=true;video.play().catch(()=>{});});

  const action=$('.bp-mobile-action');
  const observed=new Map();
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>observed.set(entry.target.id||entry.target.className,entry.isIntersecting));action.hidden=Boolean(observed.get('bp-hero bp-wrap')||observed.get('bp-gm3-link')||observed.get('bp-demo bp-wrap')||observed.get('bp-faq bp-wrap bp-section'));},{threshold:0.05});
    [$('.bp-hero'),$('#bp-gm3-link'),$('.bp-demo'),$('.bp-faq')].forEach(el=>observer.observe(el));
  }

  const isLocal=['localhost','127.0.0.1'].includes(location.hostname);
  const shopOrigin=isLocal?'https://speediance.com.au':location.origin;
  const routeRoot=window.Shopify?.routes?.root||'/';
  function fetchProduct(handle){
    const endpoint=isLocal?`/api/product/${handle}`:`${routeRoot}products/${handle}.js`;
    const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),8000);
    return fetch(endpoint,{signal:controller.signal}).then(response=>{if(!response.ok)throw new Error('Product unavailable');return response.json();}).finally(()=>clearTimeout(timer));
  }
  Promise.all([
    fetchProduct('speediance-gym-monster-3'),
    fetchProduct('speediance-premium-care-2-year-in-home-service-plan').catch(()=>null)
  ]).then(([product,premiumCare])=>{
    const candidates=(product.variants||[]).filter(variant=>variant.available&&Number(variant.price)>0).sort((a,b)=>Number(a.price)-Number(b.price));
    const first=candidates.find(v=>(v.public_title||v.title||'').trim().toLowerCase()==='gym monster 3 / studio');
    if(!first){$('#bp-gm3-price').textContent='Check Studio package availability';return;}
    const currency=product.currency||window.Shopify?.currency?.active;
    if(!currency)throw Error('Product currency unavailable');
    const lang=document.documentElement.lang||'en-AU';
    const fmt=amount=>new Intl.NumberFormat(lang,{style:'currency',currency,currencyDisplay:'narrowSymbol',maximumFractionDigits:0}).format(amount);
    const priceNow=Number(first.price)/100;
    const compareAt=first.compare_at_price?Number(first.compare_at_price)/100:null;
    const save=compareAt&&compareAt>priceNow?compareAt-priceNow:0;
    const variantUrl=`${shopOrigin}${routeRoot}products/speediance-gym-monster-3?variant=${encodeURIComponent(first.id)}`;

    $('#bp-gm3-price').innerHTML=save>0?`<s>${fmt(compareAt)}</s> ${fmt(priceNow)} <span class="bp-save-badge">Save ${fmt(save)}</span>`:fmt(priceNow);
    $('#bp-gm3-price-note').textContent='Studio package: Incline Bench and the full accessory kit included.';

    const gm3Link=$('#bp-gm3-link');
    gm3Link.innerHTML=`Get my GM3 Studio${save>0?` · Save ${fmt(save)}`:''} <span aria-hidden="true">→</span>`;
    gm3Link.href=variantUrl;

    const heroCta=$('#bp-hero-cta');
    heroCta.innerHTML=`Get my GM3 Studio${save>0?` · Save ${fmt(save)}`:''} <span aria-hidden="true">→</span>`;
    heroCta.href=variantUrl;

    $('#bp-sticky-line1').textContent=`GM3 Studio ${fmt(priceNow)}`;const stickyLine1=$('#bp-sticky-line1');if(save>0){const was=document.createElement('s');was.className='bp-sticky-was';was.textContent=fmt(compareAt);stickyLine1.append(' ',was);}
    const stickyLine2=$('#bp-sticky-line2');
    if(save>0){stickyLine2.textContent=`Save ${fmt(save)}`;stickyLine2.hidden=false;}else{stickyLine2.hidden=true;}
    $('#bp-sticky-cta').href=variantUrl;

    const careVariant=premiumCare&&Array.isArray(premiumCare.variants)?premiumCare.variants[0]:null;
    const careValue=careVariant&&Number(careVariant.price)>0?fmt(Number(careVariant.price)/100):(currency==='NZD'?'NZ$499':null);
    const careText=careValue?`Premium Care worth ${careValue}`:'Premium Care';
    const offer=$('#bp-hero-offer');
    offer.textContent=`${careText} and a personal setup session included.`;
    offer.hidden=false;
    const tickCareValue=$('#bp-tick-care-value');
    if(tickCareValue)tickCareValue.textContent=careValue?` (worth ${careValue})`:'';
  }).catch(()=>{});
}


})();
